import { useState } from 'react';
import { Header } from './Header';
import { Sidebar } from './Sidebar';

export const Navigation = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const onToggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <>
      <Header isSidebarOpen={isSidebarOpen} onToggleSidebar={onToggleSidebar} />
      <Sidebar open={isSidebarOpen} onToggleSidebar={onToggleSidebar} />
    </>
  );
};
